module.exports = __webpack_public_path__ + "img/co-pace-logo.12d2fb29.png";